$(document).ready(function () {

    $(".collection__products__list").each(function (index) {
        var nextUrl = $(this).attr("data-collection-url");
        var collection__products__list__id = $(this).attr("id");
        var flickity_grid = $(this).hasClass("flickity-grid");
        var data_collection_current_sort = $(this).attr("data-collection-current-sort");
        loadCollectionProducts(nextUrl, collection__products__list__id, flickity_grid,data_collection_current_sort);
    });

});

function loadCollectionProducts(nextUrl, collection__products__list__id, flickity_grid,data_collection_current_sort) {
    $.ajax({
        url: nextUrl,
        type: 'GET',
        dataType: 'html',
        success: function (responseHTML) {
            if (flickity_grid) {
                $(responseHTML).find('.product-grid-item-custom').each(function (index) {
                    $('#' + collection__products__list__id).append('<div class="slide-item product-grid-slide" data-carousel-slide  data-item>' + $(this).html() + '</div>');
                });
            } else {
                $(responseHTML).find('.product-grid-item-custom').each(function (index) {
                    $('#' + collection__products__list__id).append('<div class="collection-list__product" >' + $(this).html() + '</div>');
                });
            }

            var cleanUrl = nextUrl.split('?')[0];
            $(".header__menu__inner").find(".navlink").each(function(){ 
                var dataHref = $(this).attr('href');
                if(typeof dataHref !== "undefined" && dataHref.indexOf(cleanUrl) != -1){
                    if (dataHref.indexOf('?') != -1) {
                        var updatedUrl = dataHref + '&sort_by=' + data_collection_current_sort;
                    } else {
                        var updatedUrl = dataHref + '?sort_by=' + data_collection_current_sort;
                    }
                    $(this).attr("href",updatedUrl);
                }
            });
            $(".drawer__menu").find(".sliderow__title").each(function(){ 
                var dataHref = $(this).attr('href');
                if(typeof dataHref !== "undefined" && dataHref.indexOf(cleanUrl) != -1){
                    if (dataHref.indexOf('?') != -1) {
                        var updatedUrl = dataHref + '&sort_by=' + data_collection_current_sort;
                    } else {
                        var updatedUrl = dataHref + '?sort_by=' + data_collection_current_sort;
                    }
                    $(this).attr("href",updatedUrl);
                }
            });
        },
        complete: function () {

        },
    });
}